import { CivilLawSubjectType } from 'api/types/entity';
import { isGlobalProject } from 'config';
import { Maybe } from 'types/maybe';

type LegalClientRepresentative = {
  roleInCompany?: {
    civilLawSubject?: Maybe<CivilLawSubjectType>;
  };
};

export const isLegalRepresentativeCompany = (
  legalClientRepresentative: Maybe<LegalClientRepresentative>
) => {
  // Global project always has physical representative
  if (isGlobalProject()) return false;

  return (
    legalClientRepresentative?.roleInCompany?.civilLawSubject ===
    CivilLawSubjectType.JuridicalPerson
  );
};
